// extracted by mini-css-extract-plugin
export default {"base":"image_base__V3Qqu","shown":"image_shown__L2SYn"};